import api from '../../axios_api'
import _ from 'lodash'
import Promise from 'bluebird'


const state = {
    server_data: [],
}

const getters = {
    roles: (state) => state.server_data,
    getCurrentWorkspaceRolePermissions: (state, getters, rootState, rootGetters) => {
        let rolesData = JSON.parse(JSON.stringify(state.server_data));
        let workspacesData = rootGetters['workspace/workspaces'];
        let currentWorkspaceData = rootGetters['workspace/currentWorkspace'];
        let currentWorkspaceRolePermissions = [];
        let currentWorkspaceRoleData = {};
        if (currentWorkspaceData && currentWorkspaceData.hasOwnProperty('workspace_id') && currentWorkspaceData.workspace_id.length > 0) {
            let currentWorkspace = workspacesData.find((item) => {
                if (item && item.hasOwnProperty('role') && item.role.length > 0 && item.hasOwnProperty('workspace') && item.workspace && item.workspace.hasOwnProperty('_id') && item.workspace._id == currentWorkspaceData.workspace_id) {
                    return item;
                }
            });
            if (currentWorkspace && currentWorkspace.hasOwnProperty('role')) {
                currentWorkspaceRoleData = rolesData.find((item) => {
                    if (item && item.hasOwnProperty('_id') && item._id.length > 0 && item._id == currentWorkspace.role) {
                        return item;
                    }
                });
                currentWorkspaceRolePermissions = currentWorkspaceRoleData
                    && currentWorkspaceRoleData.hasOwnProperty('permissions')
                    && currentWorkspaceRoleData.permissions.length > 0
                    ? currentWorkspaceRoleData.permissions
                    : [];
            }
        }
        return currentWorkspaceRolePermissions;
    },
    checkRole: (state, getters, rootState, rootGetters) => {
        let getAllUsers = rootGetters["team/getAllUsers"];
        let account_id = rootGetters["user/id"]
        let teams = getAllUsers ? JSON.parse(JSON.stringify(getAllUsers)) : [];
        let index = teams.findIndex((item) =>
            item.account && item.account._id
                ? item.account._id == account_id
                : -1
        );
        if (
            index >= 0 &&
            teams[index] &&
            teams[index].role &&
            teams[index].role.name.length > 0
        )
            return teams[index].role.name;
        else return "";
    }
}

const mutations = {
    initialize(state) {
        state.server_data = []
    },
    merge(state, payload) {
        // merge our local with what has returned
        if (_.isNil(payload) || _.isEmpty(payload)) return
        if (!_.isArray(payload)) payload = [payload]
        state.server_data = _.map(state.server_data, addr => {
            let index = _.findIndex(payload, function (a) { return a._id === addr._id })
            if (index >= 0) {
                return _.first(_.pullAt(payload, index))
            }
            return addr
        })
        if (!_.isEmpty(payload)) state.server_data = _.concat(state.server_data, payload)
        state.server_data = _.without(state.server_data, null, undefined)
    },
}
const actions = {
    start({ state, dispatch, commit }) {
        commit('initialize')
        dispatch('getRoles')
            .then(() => {
            })
            .catch(() => { })
    },
    stop({ commit }) {
        // clean up
        commit('initialize')
    },
    cycle({ }) { },
    createOfferings({ commit }, payload) { },
    deleteOfferings({ commit }, payload) { },
    getRoles({ commit }, payload) {
        if (localStorage.fiifi) {
            let fiifi = JSON.parse(localStorage.fiifi).user
            if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0) {
                let url = `/role`;
                return api.get(url)
                    .then(res => {
                        commit('merge', res.data.encrypt.success)
                        return Promise.resolve(res.data.encrypt.success)
                    })
                    .catch(err => {
                        console.error(`Error during investment fetch: ${err}`)
                        return Promise.reject(err)
                    })
            }
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}